module.exports = __webpack_public_path__ + "static/media/academy-logo-new.64b476f5.png";